/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeListKnownPlayerDto,
  ApiEnvelopeOnlinePlayersDomainListResponse,
  ApiEnvelopeOnlinePlayersDomainSnapshotDto,
  ApiEnvelopeOnlinePlayersPlayerHistoryDto,
  OnlinePlayersSearchKnownParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type onlinePlayersGetDomainsResponse200 = {
  data: ApiEnvelopeOnlinePlayersDomainListResponse
  status: 200
}

export type onlinePlayersGetDomainsResponseSuccess = (onlinePlayersGetDomainsResponse200) & {
  headers: Headers;
};
;

export type onlinePlayersGetDomainsResponse = (onlinePlayersGetDomainsResponseSuccess)

export const getOnlinePlayersGetDomainsUrl = () => {




  return `/api/onlineplayers/domains`
}

export const useOnlinePlayersGetDomainsHook = (): ( options?: RequestInit) => Promise<onlinePlayersGetDomainsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getOnlinePlayersGetDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type onlinePlayersSearchKnownResponse200 = {
  data: ApiEnvelopeListKnownPlayerDto
  status: 200
}

export type onlinePlayersSearchKnownResponseSuccess = (onlinePlayersSearchKnownResponse200) & {
  headers: Headers;
};
;

export type onlinePlayersSearchKnownResponse = (onlinePlayersSearchKnownResponseSuccess)

export const getOnlinePlayersSearchKnownUrl = (params?: OnlinePlayersSearchKnownParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/onlineplayers/known?${stringifiedParams}` : `/api/onlineplayers/known`
}

export const useOnlinePlayersSearchKnownHook = (): (params?: OnlinePlayersSearchKnownParams, options?: RequestInit) => Promise<onlinePlayersSearchKnownResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: OnlinePlayersSearchKnownParams, options?: RequestInit) => {

        return customFetcher(getOnlinePlayersSearchKnownUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type onlinePlayersGetDomainResponse200 = {
  data: ApiEnvelopeOnlinePlayersDomainSnapshotDto
  status: 200
}

export type onlinePlayersGetDomainResponse404 = {
  data: ApiEnvelopeOnlinePlayersDomainSnapshotDto
  status: 404
}

export type onlinePlayersGetDomainResponseSuccess = (onlinePlayersGetDomainResponse200) & {
  headers: Headers;
};
export type onlinePlayersGetDomainResponseError = (onlinePlayersGetDomainResponse404) & {
  headers: Headers;
};

export type onlinePlayersGetDomainResponse = (onlinePlayersGetDomainResponseSuccess | onlinePlayersGetDomainResponseError)

export const getOnlinePlayersGetDomainUrl = (domain: string,) => {




  return `/api/onlineplayers/${domain}`
}

export const useOnlinePlayersGetDomainHook = (): (domain: string, options?: RequestInit) => Promise<onlinePlayersGetDomainResponse> => {

      const customFetcher = useSfetchMutator();
      return (domain: string, options?: RequestInit) => {

        return customFetcher(getOnlinePlayersGetDomainUrl(domain),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type onlinePlayersGetPlayerHistoryResponse200 = {
  data: ApiEnvelopeOnlinePlayersPlayerHistoryDto
  status: 200
}

export type onlinePlayersGetPlayerHistoryResponse404 = {
  data: ApiEnvelopeOnlinePlayersPlayerHistoryDto
  status: 404
}

export type onlinePlayersGetPlayerHistoryResponseSuccess = (onlinePlayersGetPlayerHistoryResponse200) & {
  headers: Headers;
};
export type onlinePlayersGetPlayerHistoryResponseError = (onlinePlayersGetPlayerHistoryResponse404) & {
  headers: Headers;
};

export type onlinePlayersGetPlayerHistoryResponse = (onlinePlayersGetPlayerHistoryResponseSuccess | onlinePlayersGetPlayerHistoryResponseError)

export const getOnlinePlayersGetPlayerHistoryUrl = (domain: string,
    name: string,) => {




  return `/api/onlineplayers/${domain}/players/${name}/history`
}

export const useOnlinePlayersGetPlayerHistoryHook = (): (domain: string,
    name: string, options?: RequestInit) => Promise<onlinePlayersGetPlayerHistoryResponse> => {

      const customFetcher = useSfetchMutator();
      return (domain: string,
    name: string, options?: RequestInit) => {

        return customFetcher(getOnlinePlayersGetPlayerHistoryUrl(domain,name),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


